import { createReducer } from "../reducerUtil"
import {
  SET_GLOBAL_STATS_DATA,
  SET_MY_STATS_DATA,
  SET_STATS_INDEX,
} from "./constants"

const initialState = {
  global: {
    tails: 0,
    heads: 0,
    yesno: {
      tails: 0,
      heads: 0,
    },
    staygo: {
      tails: 0,
      heads: 0,
    },
  },
  my: {
    tails: 0,
    heads: 0,
    yesno: {
      tails: 0,
      heads: 0,
    },
    staygo: {
      tails: 0,
      heads: 0,
    },
  },
  statsIndex: 0,
}

export const setGlobalStatsData = (state, payload) => {
  return {
    ...state,
    global: {
      tails: payload.tails || 0,
      heads: payload.heads || 0,
      yesno: {
        tails: payload.yesno?.tails || 0,
        heads: payload.yesno?.heads || 0,
      },
      staygo: {
        tails: payload.staygo?.tails || 0,
        heads: payload.staygo?.heads || 0,
      },
      onetwo: {
        tails: payload.onetwo?.tails || 0,
        heads: payload.onetwo?.heads || 0,
      },
    },
  }
}

export const setMyStatsData = (state, payload) => {
  return {
    ...state,
    my: {
      tails: payload.tails || 0,
      heads: payload.heads || 0,
      yesno: {
        tails: payload.yesno?.tails || 0,
        heads: payload.yesno?.heads || 0,
      },
      staygo: {
        tails: payload.staygo?.tails || 0,
        heads: payload.staygo?.heads || 0,
      },
      onetwo: {
        tails: payload.onetwo?.tails || 0,
        heads: payload.onetwo?.heads || 0,
      },
    },
  }
}

export const setStatsIndex = (state, payload) => {
  return {
    ...state,
    statsIndex: payload.index,
  }
}

export default createReducer(initialState, {
  [SET_GLOBAL_STATS_DATA]: setGlobalStatsData,
  [SET_MY_STATS_DATA]: setMyStatsData,
  [SET_STATS_INDEX]: setStatsIndex,
})
